import script from "./SubscribePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribePanel.vue?vue&type=script&setup=true&lang=js"

import "./SubscribePanel.vue?vue&type=style&index=0&id=0b72bbdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b72bbdc"]])

export default __exports__